import { shallowEqual, useSelector } from 'react-redux';
import { IStore } from '../../../../store/interface';
import { getHotOffersElement } from '../../selector';
import { IMarketplaceElement } from 'modules/marketplace/interfaces';

export const useHotOffersElement = (id: string) => ({
  item: useSelector<IStore, IMarketplaceElement>(getHotOffersElement(id), shallowEqual),
});
